var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"mt-5"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12","tag":"h1"}},[_c('h2',[_vm._v("Stop")]),_c('h3',[_vm._v(" Vous n'avez pas les droits nécessaires afin d'accéder à cette ressource ")]),_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v("Retourner à l'accueil ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }